<template>
  <div class="qm-editor">
    <Toolbar
      class="qm-editor-toolbar"
      :mode="simpleMode ? 'simple' : ''"
      :editor="editor"
      :defaultConfig="innerToolbarConfig"
    />
    <Editor
      class="qm-editor-editor"
      :mode="simpleMode ? 'simple' : ''"
      :style="{ height }"
      v-model="html"
      :defaultConfig="innerEditorConfig"
      @onCreated="onCreated"
    />
    <qm-picture-library
      v-if="supportImage && pictureLibrary"
      :visible.sync="visible"
      :append-to-body="true"
      :activeName="activeName"
      v-bind="{ multiple: true, ...pictureLibraryProps }"
      @change="onChange"
    >
    </qm-picture-library>
    <UploadVideoPop
      v-if="supportVideo"
      ref="uploadVideoPop"
      useScene="editor"
      uploadType="aliyun"
      @videoUploadedSuccess="onVideoChange"
    />
  </div>
</template>

<script>
import { DomEditor } from '@wangeditor/editor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import ajax from 'packages/upload/src/ajax'
import deepmerge from 'deepmerge'
import UploadVideoPop from 'packages/qm-picture-library/src/components/upload-video-pop.vue'
import { getVideoInfo } from 'packages/qm-picture-library/src/api'

export default {
  name: 'QmEditor',
  components: { Editor, Toolbar, UploadVideoPop },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '300px',
    },
    placeholder: {
      type: String,
      default: '',
    },
    supportImage: {
      type: Boolean,
      default: true,
    },
    pictureLibrary: {
      type: Boolean,
      default: true,
    },
    pictureLibraryProps: {
      type: Object,
      default: () => ({}),
    },
    supportVideo: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    simpleMode: {
      type: Boolean,
      default: false,
    },
    toolbarConfig: {
      type: Object,
      default: () => ({}),
    },
    editorConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      editor: null,
      html: '',
      visible: false,
      activeName: '',
    }
  },
  watch: {
    disabled(val) {
      if (val) {
        this.editor.disable()
      } else {
        this.editor.enable()
      }
    },
    value(val) {
      this.$nextTick(() => {
        this.html = val
      })
    },
    html(val) {
      this.$nextTick(() => {
        this.$emit('change', this.editor.isEmpty() ? '' : val)
      })
    },
  },
  created() {
    this.innerToolbarConfig = deepmerge(
      {
        excludeKeys: [],
      },
      this.toolbarConfig
    )
    this.innerEditorConfig = deepmerge(
      {
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadFile,
          },
          insertImage: {
            checkImage: () => {
              if (this.supportImage === false) {
                return undefined
              }
              return true
            },
          },
          uploadVideo: {},
        },
        readOnly: false,
      },
      this.editorConfig
    )

    this.innerEditorConfig.readOnly = this.disabled
    this.innerEditorConfig.placeholder = this.placeholder
    if (this.supportImage === false) {
      this.innerToolbarConfig.excludeKeys.push('group-image')
    }
    if (this.supportVideo === false) {
      this.innerToolbarConfig.excludeKeys.push('group-video')
    }
    if (this.supportImage && this.pictureLibrary) {
      this.innerEditorConfig.MENU_CONF.uploadImage.customBrowseAndUpload = insertFn => {
        this.activeName = 'picture'
        this.visible = true
        this._callback = res => {
          res.forEach(({ fullPath: img }) => {
            insertFn(img)
          })
        }
      }
    }
    if (this.supportVideo) {
      if (this.pictureLibrary) {
        this.innerEditorConfig.MENU_CONF.uploadVideo.customBrowseAndUpload = insertFn => {
          this.activeName = 'video'
          this.visible = true
          this._callback = res => {
            res.forEach(({ playUrl: url, coverUrl: poster }) => {
              insertFn(url, poster)
            })
          }
        }
      } else {
        this.innerEditorConfig.MENU_CONF.uploadVideo.customBrowseAndUpload = insertFn => {
          this.$refs.uploadVideoPop.show()
          this._videoCallBack = async ({ cover_url: poster, play_id: videoId }) => {
            const res = await getVideoInfo(videoId)
            const { FileURL: url } = res.data && res.data.Mezzanine
            insertFn(url, poster)
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.html = this.value
    })
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor)
      // this.$nextTick(() => {
      // console.log(DomEditor.getToolbar(this.editor).getConfig())
      // })
    },
    uploadFile(file, insertFn) {
      const { hostname } = window.location
      const domain = hostname.slice(hostname.indexOf('.') + 1)
      const data = new FormData()
      data.append('upfile', file)
      ajax({
        method: 'POST',
        file,
        data,
        filename: 'upfile',
        action: `//inapi.${domain}/${this.$gateway}/coroutine/picture/file/upload`,
        withCredentials: true,
        onSuccess: res => {
          if (res.status) {
            insertFn(res.data.cloudDomain + '/' + res.data.image_path)
          } else {
            this.$message.error(res.message)
          }
        },
        onProgress() {},
      })
    },
    onChange(res) {
      this._callback && this._callback(res)
    },
    onVideoChange(res) {
      this._videoCallBack && this._videoCallBack(res)
    },
  },
  beforeDestroy() {
    this.editor && this.editor.destroy()
  },
}
</script>
